import { render, staticRenderFns } from "./AreaGroupDropdown.vue?vue&type=template&id=65619da7&scoped=true&"
import script from "./AreaGroupDropdown.vue?vue&type=script&lang=js&"
export * from "./AreaGroupDropdown.vue?vue&type=script&lang=js&"
import style0 from "./AreaGroupDropdown.vue?vue&type=style&index=0&id=65619da7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65619da7",
  null
  
)

export default component.exports